export interface CurrencyOption {
  code: string;
  label: string;
  symbol: string;
}

/** ISO 4217 currencies (matches invoice-generator.com selector). */
export const CURRENCIES: CurrencyOption[] = [
  { code: 'USD', label: 'USD ($)', symbol: '$' },
  { code: 'EUR', label: 'EUR (€)', symbol: '€' },
  { code: 'GBP', label: 'GBP (£)', symbol: '£' },
  { code: 'AED', label: 'AED (د.إ)', symbol: 'د.إ' },
  { code: 'AFN', label: 'AFN', symbol: '؋' },
  { code: 'ALL', label: 'ALL (Lek)', symbol: 'Lek' },
  { code: 'AMD', label: 'AMD', symbol: '֏' },
  { code: 'AOA', label: 'AOA (Kz)', symbol: 'Kz' },
  { code: 'ARS', label: 'ARS ($)', symbol: '$' },
  { code: 'AUD', label: 'AUD ($)', symbol: '$' },
  { code: 'AWG', label: 'AWG (ƒ)', symbol: 'ƒ' },
  { code: 'AZN', label: 'AZN (ман)', symbol: 'ман' },
  { code: 'BAM', label: 'BAM (KM)', symbol: 'KM' },
  { code: 'BBD', label: 'BBD', symbol: '$' },
  { code: 'BDT', label: 'BDT', symbol: '৳' },
  { code: 'BGN', label: 'BGN', symbol: 'лв' },
  { code: 'BHD', label: 'BHD', symbol: '.د.ب' },
  { code: 'BIF', label: 'BIF', symbol: 'Fr' },
  { code: 'BMD', label: 'BMD', symbol: '$' },
  { code: 'BND', label: 'BND', symbol: '$' },
  { code: 'BOB', label: 'BOB', symbol: 'Bs.' },
  { code: 'BRL', label: 'BRL (R$)', symbol: 'R$' },
  { code: 'BSD', label: 'BSD', symbol: '$' },
  { code: 'BTN', label: 'BTN', symbol: 'Nu.' },
  { code: 'BWP', label: 'BWP', symbol: 'P' },
  { code: 'BYN', label: 'BYN', symbol: 'Br' },
  { code: 'BZD', label: 'BZD', symbol: '$' },
  { code: 'CAD', label: 'CAD ($)', symbol: '$' },
  { code: 'CDF', label: 'CDF', symbol: 'Fr' },
  { code: 'CHF', label: 'CHF', symbol: 'Fr' },
  { code: 'CLP', label: 'CLP ($)', symbol: '$' },
  { code: 'CNY', label: 'CNY (¥)', symbol: '¥' },
  { code: 'COP', label: 'COP ($)', symbol: '$' },
  { code: 'CRC', label: 'CRC (₡)', symbol: '₡' },
  { code: 'CUP', label: 'CUP', symbol: '$' },
  { code: 'CVE', label: 'CVE', symbol: '$' },
  { code: 'CZK', label: 'CZK (Kč)', symbol: 'Kč' },
  { code: 'DJF', label: 'DJF', symbol: 'Fr' },
  { code: 'DKK', label: 'DKK (kr)', symbol: 'kr' },
  { code: 'DOP', label: 'DOP (RD$)', symbol: 'RD$' },
  { code: 'DZD', label: 'DZD', symbol: 'د.ج' },
  { code: 'EGP', label: 'EGP (£)', symbol: '£' },
  { code: 'ERN', label: 'ERN', symbol: 'Nfk' },
  { code: 'ETB', label: 'ETB', symbol: 'Br' },
  { code: 'FJD', label: 'FJD', symbol: '$' },
  { code: 'FKP', label: 'FKP (£)', symbol: '£' },
  { code: 'GEL', label: 'GEL (₾)', symbol: '₾' },
  { code: 'GHS', label: 'GHS (₵)', symbol: '₵' },
  { code: 'GIP', label: 'GIP (£)', symbol: '£' },
  { code: 'GMD', label: 'GMD', symbol: 'D' },
  { code: 'GNF', label: 'GNF', symbol: 'Fr' },
  { code: 'GTQ', label: 'GTQ (Q)', symbol: 'Q' },
  { code: 'GYD', label: 'GYD', symbol: '$' },
  { code: 'HKD', label: 'HKD ($)', symbol: '$' },
  { code: 'HNL', label: 'HNL (L)', symbol: 'L' },
  { code: 'HTG', label: 'HTG', symbol: 'G' },
  { code: 'HUF', label: 'HUF (Ft)', symbol: 'Ft' },
  { code: 'IDR', label: 'IDR (Rp)', symbol: 'Rp' },
  { code: 'ILS', label: 'ILS (₪)', symbol: '₪' },
  { code: 'INR', label: 'INR (₹)', symbol: '₹' },
  { code: 'IQD', label: 'IQD', symbol: 'ع.د' },
  { code: 'IRR', label: 'IRR', symbol: '﷼' },
  { code: 'ISK', label: 'ISK (kr)', symbol: 'kr' },
  { code: 'JMD', label: 'JMD (J$)', symbol: 'J$' },
  { code: 'JOD', label: 'JOD', symbol: 'د.ا' },
  { code: 'JPY', label: 'JPY (¥)', symbol: '¥' },
  { code: 'KES', label: 'KES', symbol: 'Sh' },
  { code: 'KGS', label: 'KGS', symbol: 'с' },
  { code: 'KHR', label: 'KHR (៛)', symbol: '៛' },
  { code: 'KMF', label: 'KMF', symbol: 'Fr' },
  { code: 'KRW', label: 'KRW (₩)', symbol: '₩' },
  { code: 'KWD', label: 'KWD', symbol: 'د.ك' },
  { code: 'KYD', label: 'KYD', symbol: '$' },
  { code: 'KZT', label: 'KZT (₸)', symbol: '₸' },
  { code: 'LAK', label: 'LAK (₭)', symbol: '₭' },
  { code: 'LBP', label: 'LBP', symbol: 'ل.ل' },
  { code: 'LKR', label: 'LKR', symbol: 'Rs' },
  { code: 'LRD', label: 'LRD', symbol: '$' },
  { code: 'LSL', label: 'LSL', symbol: 'L' },
  { code: 'LYD', label: 'LYD', symbol: 'ل.د' },
  { code: 'MAD', label: 'MAD', symbol: 'د.م.' },
  { code: 'MDL', label: 'MDL', symbol: 'L' },
  { code: 'MGA', label: 'MGA', symbol: 'Ar' },
  { code: 'MKD', label: 'MKD', symbol: 'ден' },
  { code: 'MMK', label: 'MMK', symbol: 'K' },
  { code: 'MNT', label: 'MNT (₮)', symbol: '₮' },
  { code: 'MOP', label: 'MOP', symbol: 'P' },
  { code: 'MRU', label: 'MRU', symbol: 'UM' },
  { code: 'MUR', label: 'MUR', symbol: '₨' },
  { code: 'MVR', label: 'MVR', symbol: '.ރ' },
  { code: 'MWK', label: 'MWK', symbol: 'MK' },
  { code: 'MXN', label: 'MXN ($)', symbol: '$' },
  { code: 'MYR', label: 'MYR (RM)', symbol: 'RM' },
  { code: 'MZN', label: 'MZN', symbol: 'MT' },
  { code: 'NAD', label: 'NAD', symbol: '$' },
  { code: 'NGN', label: 'NGN (₦)', symbol: '₦' },
  { code: 'NIO', label: 'NIO (C$)', symbol: 'C$' },
  { code: 'NOK', label: 'NOK (kr)', symbol: 'kr' },
  { code: 'NPR', label: 'NPR', symbol: '₨' },
  { code: 'NZD', label: 'NZD ($)', symbol: '$' },
  { code: 'OMR', label: 'OMR', symbol: 'ر.ع.' },
  { code: 'PAB', label: 'PAB', symbol: 'B/.' },
  { code: 'PEN', label: 'PEN (S/)', symbol: 'S/' },
  { code: 'PGK', label: 'PGK', symbol: 'K' },
  { code: 'PHP', label: 'PHP (₱)', symbol: '₱' },
  { code: 'PKR', label: 'PKR', symbol: '₨' },
  { code: 'PLN', label: 'PLN (zł)', symbol: 'zł' },
  { code: 'PYG', label: 'PYG (₲)', symbol: '₲' },
  { code: 'QAR', label: 'QAR', symbol: 'ر.ق' },
  { code: 'RON', label: 'RON (lei)', symbol: 'lei' },
  { code: 'RSD', label: 'RSD', symbol: 'дин.' },
  { code: 'RUB', label: 'RUB (₽)', symbol: '₽' },
  { code: 'RWF', label: 'RWF', symbol: 'Fr' },
  { code: 'SAR', label: 'SAR', symbol: 'ر.س' },
  { code: 'SBD', label: 'SBD', symbol: '$' },
  { code: 'SCR', label: 'SCR', symbol: '₨' },
  { code: 'SEK', label: 'SEK (kr)', symbol: 'kr' },
  { code: 'SGD', label: 'SGD ($)', symbol: '$' },
  { code: 'SHP', label: 'SHP (£)', symbol: '£' },
  { code: 'SLE', label: 'SLE', symbol: 'Le' },
  { code: 'SOS', label: 'SOS', symbol: 'Sh' },
  { code: 'SRD', label: 'SRD', symbol: '$' },
  { code: 'SSP', label: 'SSP', symbol: '£' },
  { code: 'STN', label: 'STN', symbol: 'Db' },
  { code: 'SVC', label: 'SVC', symbol: '$' },
  { code: 'SYP', label: 'SYP', symbol: '£' },
  { code: 'SZL', label: 'SZL', symbol: 'L' },
  { code: 'THB', label: 'THB (฿)', symbol: '฿' },
  { code: 'TJS', label: 'TJS', symbol: 'ЅМ' },
  { code: 'TMT', label: 'TMT', symbol: 'm' },
  { code: 'TND', label: 'TND', symbol: 'د.ت' },
  { code: 'TOP', label: 'TOP (T$)', symbol: 'T$' },
  { code: 'TRY', label: 'TRY (₺)', symbol: '₺' },
  { code: 'TTD', label: 'TTD', symbol: '$' },
  { code: 'TWD', label: 'TWD (NT$)', symbol: 'NT$' },
  { code: 'TZS', label: 'TZS', symbol: 'Sh' },
  { code: 'UAH', label: 'UAH (₴)', symbol: '₴' },
  { code: 'UGX', label: 'UGX', symbol: 'Sh' },
  { code: 'UYU', label: 'UYU ($)', symbol: '$' },
  { code: 'UZS', label: 'UZS', symbol: 'so\'m' },
  { code: 'VES', label: 'VES', symbol: 'Bs.S' },
  { code: 'VND', label: 'VND (₫)', symbol: '₫' },
  { code: 'VUV', label: 'VUV', symbol: 'Vt' },
  { code: 'WST', label: 'WST', symbol: 'T' },
  { code: 'XAF', label: 'XAF', symbol: 'Fr' },
  { code: 'XCD', label: 'XCD', symbol: '$' },
  { code: 'XOF', label: 'XOF', symbol: 'Fr' },
  { code: 'XPF', label: 'XPF', symbol: 'Fr' },
  { code: 'YER', label: 'YER', symbol: '﷼' },
  { code: 'ZAR', label: 'ZAR (R)', symbol: 'R' },
  { code: 'ZMW', label: 'ZMW', symbol: 'ZK' },
];

export function currencySymbol(code: string): string {
  return CURRENCIES.find((c) => c.code === code)?.symbol ?? code;
}
